<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container" >
      <div class="container-fluid">
        <div class="row">
          <div class="col-3">
            <smallBar :user="user"></smallBar>
          </div>
          <div class="col-9">
            <div class="widget-wrap">
              <div class="widget-header block-header margin-bottom-0 clearfix">
                <div class="pull-left">
                  <h3>帳單一覽</h3>
                </div>
              </div>
              <div class="widget-container">
                <div class="widget-content" v-if="orders.length == 0">
                  <p>目前無任何付款紀錄。</p>
                </div>
                <div class="widget-content" v-else>
                	<table class="table table-bordered">
                		<tr>
                			<th class="text-center">帳單編號</th>
                			<th class="text-center">內容</th>
                			<th class="text-center">金額</th>
                			<th class="text-center">狀態</th>
                			<th class="text-center">時間</th>
                		</tr>
                		<tr v-for="order in orders">
                			<td>{{order.no}}</td>
                			<td>{{order.name}}</td>
                			<td>$ {{order.amount.toLocaleString()}}</td>
                			<td><div v-html="getOrderStatus(order.status)"></div></td>
                			<td>
                				<p v-if="order.status == 'paid'">付款時間：{{order.paid_at}}</p>
                				<p v-if="order.status == 'refunded'">退款時間：{{order.refund_at}}</p>
                			</td>
                		</tr>
                	</table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- modal template end-->
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
    <!--Page Container End Here-->
  </div>
</template>

<script>
import Simplert from 'vue2-simplert'
import smallBar from './SmallBar.vue';
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'

export default {
  name: 'bill',
  components: {
    Simplert,smallBar
  },
  data() {
    return {
      refs: this.$refs,
      auth_token: '',
      orders: '',
      temp_order: '',
      showTempOrderModal: false,
    }
  },
  created() {
  	this.getOrders();
  },
  props: ['toggle_aside','user'],
  mounted() {
    
  },
  methods: {
    getOrders(){
    	// defiine vm to assign this (assign vue data) because in axios there is other this
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.axios.get('orders').then(
        function(response) {
          if (response.status == 200 && response['data']['status'] == "success") {
            vm.orders = response['data']['data']['orders']
          } else {
            vm.$toastr.w(
				      "帳單資料抓取失敗，請重新整理或稍後再試"
				    );
          }
        }).catch(function(error) {
        vm.$toastr.w(
		      "帳單資料抓取失敗，請重新整理或稍後再試"
		    );
      });
    },
    getOrderStatus(status){
    	var a = ''
    	switch(status){
	    	case "paid":
	    		a='<span class="label label-success">已付款</span>'
	    		break;
	    	case "refunding":
	    		a='退款中'
	    		break;
	    	case "refunded":
	    		a='退款完成'
	    		break;
	    	case "waiting":
	    		a='<span class="label label-warning">未付款</span>'
	    		break;
    	}
    	return a
    }
  },
}
</script>


// WEBPACK FOOTER //
// Bills.vue?20ab2ae2